export const meta = {
  name: 'Button',
  alias: 'button'
};
